export const GCLID = 'gclid';
export const MSCLKID = 'msclkid';
export const PREVIOUS_PATH = 'previousPath';
export const HAS_VIEWED_PRIVACY_SETTINGS_DIALOG =
  'has-viewed-privacy-settings-dialog';
